import { Moon, Sun } from 'lucide-react';

import { useTranslation } from '@sshop/i18n';

import { useTheme } from '@/shared/hooks/useTheme';

import { themeToggleStyles as s } from './ThemeToggle.styles';

export function ThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme();
  const { t } = useTranslation();
  const isDark = resolvedTheme === 'dark';
  const Icon = isDark ? Sun : Moon;

  return (
    <button
      type="button"
      aria-label={t('theme.toggle')}
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
      className={s.trigger}
    >
      <Icon className={s.triggerIcon} aria-hidden />
    </button>
  );
}
